import { render, staticRenderFns } from "./InitAgung.vue?vue&type=template&id=5e186bcc&scoped=true"
import script from "./InitAgung.vue?vue&type=script&lang=js"
export * from "./InitAgung.vue?vue&type=script&lang=js"
import style0 from "./InitAgung.vue?vue&type=style&index=0&id=5e186bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e186bcc",
  null
  
)

export default component.exports